<template>
    <font-awesome-icon v-if="iconComponent" :icon="iconComponent" v-bind="$attrs" />
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { proLightIconImports } from '../../util/fa-pro-light-icon-map';

@Component({
    components: { FontAwesomeIcon },
})
export default class DynamicFaIcon extends Vue {
    @Prop({ required: true }) readonly iconName!: string;

    get fullIconName(): string {
        if (this.iconName.startsWith('fa')) {
            return this.iconName;
        }
        const pascal = this.iconName
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join('');
        return `fa${pascal}`;
    }

    iconComponent: [string, string] | null = null;

    mounted() {
        this.loadIcon();
    }

    @Watch('iconName')
    onIconNameChanged() {
        this.loadIcon();
    }

    async loadIcon() {
        if (!this.iconName) {
            this.iconComponent = null;
            return;
        }

        const importFn = proLightIconImports[this.fullIconName];
        if (!importFn) {
            this.iconComponent = null;
            return;
        }
        try {
            const module = await importFn();
            const iconDef = module[this.fullIconName];
            if (iconDef) {
                library.add(iconDef);
                const iconShort = this.iconName.replace(/^fa/, '');
                this.iconComponent = ['fal', iconShort.charAt(0).toLowerCase() + iconShort.slice(1)];
            } else {
                this.iconComponent = null;
            }
        } catch (e) {
            this.iconComponent = null;
        }
    }
}
</script>
